import React, { useState } from 'react';

interface AthleteRemoveButtonProps {
  onClick: (e: React.MouseEvent) => void;
  title?: string;
  size?: 'xs' | 'sm' | 'md';
  loading?: boolean;
}

/** × icon — removes athlete from coach list without selecting the row. */
export function AthleteRemoveButton({
  onClick,
  title = 'Remove athlete',
  size = 'sm',
  loading = false,
}: AthleteRemoveButtonProps) {
  const [hovered, setHovered] = useState(false);
  const iconSize = size === 'xs' ? 12 : size === 'sm' ? 14 : 16;
  const active = hovered || loading;

  return (
    <button
      type="button"
      className="title-bar-no-drag athlete-remove-btn"
      title={title}
      aria-label={title}
      disabled={loading}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        color: active ? '#dc2626' : 'var(--fg-4)',
        opacity: loading ? 0.55 : 1,
        cursor: loading ? 'wait' : 'pointer',
      }}
    >
      <CloseIcon size={iconSize} />
    </button>
  );
}

function CloseIcon({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      aria-hidden
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}
